import React from "react";
import { BrandLogo } from "@/components/Brand";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Compass, Clock, Sparkles, LogOut } from "lucide-react";

export default function WaitlistPending() {
    const { user, logout } = useAuth();

    return (
        <div className="min-h-screen bg-cream">
            <header className="bg-cream/80 backdrop-blur-sm border-b border-[#E2E8F0]/60">
                <div className="max-w-3xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
                    <Link to="/" className="flex items-center gap-2.5">
                        <BrandLogo className="h-6" />
                    </Link>
                    <button onClick={logout} data-testid="pending-logout" className="text-sm font-medium text-[#4C5551] hover:text-teal-dark inline-flex items-center gap-1">
                        <LogOut size={16} strokeWidth={1.6} /> Sign out
                    </button>
                </div>
            </header>

            <main className="max-w-2xl mx-auto px-4 sm:px-6 py-16 md:py-24 animate-fade-in-up text-center">
                <div className="inline-flex w-16 h-16 rounded-full bg-yellow-soft text-yellow-dark items-center justify-center mb-5">
                    <Clock size={28} strokeWidth={1.6} />
                </div>
                <p className="text-sm uppercase tracking-wider font-semibold text-yellow-dark">Application received</p>
                <h1 className="mt-2 text-4xl md:text-5xl font-heading font-semibold tracking-tight">
                    Your application is under review.
                </h1>
                <p className="mt-4 text-lg text-[#4C5551] max-w-lg mx-auto leading-relaxed">
                    Thanks {user?.name?.split(" ")[0] || "for applying"} — we&apos;ll reach out within a
                    few days. Memory Lane is in private beta and we&apos;re onboarding families one at
                    a time so the experience stays calm and personal.
                </p>

                <div className="ml-card p-6 md:p-7 mt-8 text-left bg-teal-soft !border-teal-soft" data-testid="pending-meta">
                    <p className="text-xs uppercase tracking-wider font-semibold text-teal-dark mb-1">Your application</p>
                    <p className="text-[#1F2624]"><strong>Email:</strong> {user?.email}</p>
                    {user?.relationship && (
                        <p className="text-[#1F2624] mt-1"><strong>Relationship:</strong> {user.relationship.replace(/_/g, ' ')}</p>
                    )}
                    {user?.biggest_challenge && (
                        <p className="text-[#1F2624] mt-1"><strong>Challenge:</strong> {user.biggest_challenge}</p>
                    )}
                </div>

                <div className="mt-8 inline-flex items-center gap-2 text-sm text-[#4C5551]">
                    <Sparkles size={14} strokeWidth={1.8} className="text-teal-dark" />
                    While you wait, take a look at the <Link to="/demo" className="text-teal-dark font-medium underline">demo</Link> and our <Link to="/resources" className="text-teal-dark font-medium underline">resources</Link>.
                </div>
            </main>
        </div>
    );
}
